import FormWidgetRule from './form-widget-rule.config'
import Vue from 'vue'
const apis = {
  QUERY_STATISTICS_VALUE: {
    url: '/xdap-app/business/query/statisticValue',
    method: 'post',
    disableSuccessMsg: true
  }
}
const initDataStatistics = (...args) => {
  console.log(args)
  console.log(JSON.stringify(args[7]))
  const request = {
    ...apis.QUERY_STATISTICS_VALUE,
    params: {
      formId: args[4],
      documentId: args[5],
      uuidList: args[6],
      data: JSON.stringify(args[7]) === '{}' ? { temp: 'temp' } : args[7]
    }
  }
  Vue.prototype
    .$request(request)
    .asyncThen(
      (resp) => {
        args[8](resp)
      },
      () => {
        const resp = { code: 'error' }
        args[8](resp)
      }
    )
    .asyncErrorCatch(() => {
      const resp = { code: 'error' }
      args[8](resp)
    })
}
const FormDataStatisticsConfig = {
  // 类型
  componentType: 'FORM_DATA_STATISTICS',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-data-statistics',
    text: '数据统计',
    description: '用于实时统计其他表单的数据'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormDataStatistics',
      edit: 'FormDataStatistics',
      read: 'FormDataStatistics'
    },
    label: '数据统计',
    enableRule: false,
    statisticalDataSource: {
      sourceMenu: '',
      statisticsField: '',
      statisticstype: ''
    },
    ...FormWidgetRule,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcInitDataStatistics: {
        read: initDataStatistics,
        edit: initDataStatistics
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'DATA_SOURCE_CONFIG',
    'DATA_FILTER',
    'WIDTH',
    'SHOW_DATA_BY_PERMISSION',
    'HIDDEN'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormDataStatisticsConfig
